import axios from "axios";
import { Apis } from "constants/apis";
import { getToken } from "utils/token";

const getStripeUserPortalLink = async () => {
    const { data } = await axios.get(Apis.GET_STRIPE_USER_PORTAL_LINK, { headers: { Authorization: getToken() } })
    return data;
}

export default getStripeUserPortalLink